import {API_ENTRYPOINT} from '@/config/entrypoint';

// Fire-and-forget log chyby na backend (viz
// docs/superpowers/specs/2026-08-11-frontend-error-logging-design.md) -
// nikdy nesmí sama shodit UI ani zdržet. Sdíleno mezi main.js (globální
// safety-net) a store/modules/journey/actions.js (odchycené chyby z API volání).
export function logFrontendError(message, stackTrace) {
    try {
        const token = sessionStorage.getItem('token');
        const headers = {'Content-Type': 'application/json'};
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        const entryPoint = API_ENTRYPOINT + (API_ENTRYPOINT.endsWith('/') ? '' : '/') + 'api/log-frontend-error';
        fetch(entryPoint, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                message: message ? String(message) : 'Unknown error',
                stackTrace: stackTrace ? String(stackTrace) : null,
                url: window.location.href,
            }),
        }).catch(() => {});
    } catch (e) {
        // Logování chyby nesmí samo způsobit další chybu.
    }
}
